import { Card, SxProps } from "@mui/material";
import React from "react";

interface CardProps {
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
  sx?: SxProps;
}

export const AppCard: React.FC<CardProps> = ({ onClick, className = "", children, sx }) => {
  return (
    <Card
      className={"klayo_peoplecard " + className}
      onClick={() => onClick?.()}
      sx={{
        cursor: onClick ? "pointer" : "default",
        ...sx
      }}
    >
      {children}
    </Card>
  );
};
